export default "__VITE_ASSET__CMnXssDP__"